import { GlobeHemisphereWest, Airplane, GlobeHemisphereEast, Globe } from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "../Reveal";

const CORRIDORS = [
    {
        icon: GlobeHemisphereWest,
        title: "GCC",
        tags: ["UAE", "Oman", "Saudi Arabia"],
        text: "Strong healthcare demand, proximity to India and a growing international patient ecosystem.",
        span: "lg:col-span-7",
    },
    {
        icon: Airplane,
        title: "United Kingdom",
        tags: ["UK → India"],
        text: "Helping patients explore high-quality private healthcare options in India.",
        span: "lg:col-span-5",
    },
    {
        icon: Globe,
        title: "Africa",
        tags: ["Kenya", "Tanzania", "Ghana", "Nigeria"],
        text: "Building trusted healthcare pathways between African patients and Indian providers.",
        span: "lg:col-span-5",
    },
    {
        icon: GlobeHemisphereEast,
        title: "Central Asia",
        tags: ["Uzbekistan", "Kazakhstan"],
        text: "Creating multilingual healthcare navigation for emerging medical-travel markets.",
        span: "lg:col-span-7",
    },
];

export default function Corridors() {
    return (
        <section data-testid="corridors-section" className="py-28 lg:py-36 bg-tint-slate noise-overlay">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <SectionHeading
                    chapter="06"
                    eyebrow="Global Corridors"
                    title="Building healthcare corridors across borders."
                    description="We are initially focused on developing high-potential healthcare corridors connecting international patients with India's healthcare ecosystem."
                    testid="corridors-heading"
                />
                <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6">
                    {CORRIDORS.map((c, i) => (
                        <Reveal key={c.title} delay={0.08 * i} className={c.span}>
                            <div
                                data-testid={`corridor-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}
                                className="group h-full bg-white rounded-3xl border border-slate-100 p-10 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_24px_48px_rgb(10,37,64,0.10)] transition-[transform,box-shadow] duration-300"
                            >
                                <div className="flex items-start justify-between gap-6">
                                    <div className="w-13 h-13 p-3 rounded-2xl bg-tint-blue text-brand-blue group-hover:bg-brand-blue group-hover:text-white transition-colors duration-300">
                                        <c.icon size={28} weight="duotone" />
                                    </div>
                                    <div className="flex flex-wrap justify-end gap-2">
                                        {c.tags.map((t) => (
                                            <span key={t} className="rounded-full bg-tint-green px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-brand-green">
                                                {t}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                                <h3 className="mt-7 font-heading text-2xl font-semibold text-brand-blue">{c.title}</h3>
                                <p className="mt-3 text-base leading-relaxed text-slate-600 max-w-md">{c.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.3}>
                    <p data-testid="corridors-disclaimer" className="mt-10 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-5 py-2.5 text-xs font-medium text-slate-500">
                        <span className="w-1.5 h-1.5 rounded-full bg-brand-green" />
                        Initial target markets — subject to market validation and partnership development.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
